import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createElementVNode as _createElementVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-28f164a6"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "enroll"
};
const _hoisted_2 = {
  class: "header"
};
const _hoisted_3 = {
  key: 0,
  class: "table mohu"
};
const _hoisted_4 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "总分", -1));
const _hoisted_5 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "复试成绩", -1));
const _hoisted_6 = {
  key: 0,
  class: "mohu-filter"
};
const _hoisted_7 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "解锁", -1));
const _hoisted_8 = {
  key: 1,
  class: "table mohu"
};
const _hoisted_9 = {
  key: 0,
  class: "mohu-filter"
};
const _hoisted_10 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "解锁", -1));
import { Bell } from "@element-plus/icons-vue";
import { ref, onMounted } from "vue";
import { useList, fushiList } from "@/api/api";
import { decrypt } from "@/utils/parseDate";
import { ElMessage, ElMessageBox } from "element-plus";
import "element-plus/theme-chalk/el-message-box.css";
import { useStore } from "vuex";
export default {
  __name: 'Enroll',
  props: {
    majorId: String
  },
  emits: ["onChange"],
  setup(__props, {
    expose: __expose,
    emit
  }) {
    const props = __props;
    const store = useStore();

    // 将 myMethod 暴露给父组件
    __expose({
      childMethod
    });
    function childMethod() {
      getUseList();
      getFushiList();
    }
    function onTips(row) {
      ElMessageBox.confirm(row.text, {
        title: "提示",
        type: "warning",
        center: true
      }).then(() => {}).catch(() => {});
    }
    const filterTag = (value, row) => {
      return row.enrollFlagStr === value;
    };
    // 点击tab
    const activeName = ref(1);
    const handleClick = event => {
      console.log(event);
      if (event == 1) {
        getUseList();
      } else if (event == 2) {
        getFushiList();
      }
    };
    // 点击解锁
    function onUnlock() {
      emit("onChange", {
        isUnlock: true
      });
    }
    const tableData = ref([]);
    const loading = ref(false);

    // 选择的年份
    const selectYear = ref("");
    const yearOptions = ref([]);
    // 所有数据
    const allData = ref([]);
    // 是否显示模糊效果
    const isUnlock = ref(false);
    // 获取录取名单
    async function getUseList() {
      try {
        tableData.value = [];
        allData.value = [];
        selectYear.value = "";
        yearOptions.value = [];
        loading.value = true;
        const data = {
          majorOutRelationId: props.majorId
        };
        const result = await useList(data);
        const res = JSON.parse(decrypt(result));
        if (res.status == 8) {
          store.commit("setTipsDialog", true);
        }
        if (res.status == 9) {
          store.commit("setNumberDialog", true);
        }
        if (res.status == 666) {
          ElMessage({
            message: res.msg,
            type: "warning",
            showClose: true
          });
          isUnlock.value = true;
          emit("onChange", {
            isUnlock: true
          });
          tableData.value = [{
            ssnf: "请解锁查看",
            zymc: "请解锁查看",
            zydm: "请解锁查看",
            yjfxnr: "请解锁查看",
            xm: "请解锁查看",
            yzyxxmc: "请解锁查看",
            zcj: "请解锁查看",
            cs: "请解锁查看",
            fs: "请解锁查看"
          }, {
            ssnf: "请解锁查看",
            zymc: "请解锁查看",
            zydm: "请解锁查看",
            yjfxnr: "请解锁查看",
            xm: "请解锁查看",
            yzyxxmc: "请解锁查看",
            zcj: "请解锁查看",
            cs: "请解锁查看",
            fs: "请解锁查看"
          }, {
            ssnf: "请解锁查看",
            zymc: "请解锁查看",
            zydm: "请解锁查看",
            yjfxnr: "请解锁查看",
            xm: "请解锁查看",
            yzyxxmc: "请解锁查看",
            zcj: "请解锁查看",
            cs: "请解锁查看",
            fs: "请解锁查看"
          }, {
            ssnf: "请解锁查看",
            zymc: "请解锁查看",
            zydm: "请解锁查看",
            yjfxnr: "请解锁查看",
            xm: "请解锁查看",
            yzyxxmc: "请解锁查看",
            zcj: "请解锁查看",
            cs: "请解锁查看",
            fs: "请解锁查看"
          }, {
            ssnf: "请解锁查看",
            zymc: "请解锁查看",
            zydm: "请解锁查看",
            yjfxnr: "请解锁查看",
            xm: "请解锁查看",
            yzyxxmc: "请解锁查看",
            zcj: "请解锁查看",
            cs: "请解锁查看",
            fs: "请解锁查看"
          }, {
            ssnf: "请解锁查看",
            zymc: "请解锁查看",
            zydm: "请解锁查看",
            yjfxnr: "请解锁查看",
            xm: "请解锁查看",
            yzyxxmc: "请解锁查看",
            zcj: "请解锁查看",
            cs: "请解锁查看",
            fs: "请解锁查看"
          }, {
            ssnf: "请解锁查看",
            zymc: "请解锁查看",
            zydm: "请解锁查看",
            yjfxnr: "请解锁查看",
            xm: "请解锁查看",
            yzyxxmc: "请解锁查看",
            zcj: "请解锁查看",
            cs: "请解锁查看",
            fs: "请解锁查看"
          }, {
            ssnf: "请解锁查看",
            zymc: "请解锁查看",
            zydm: "请解锁查看",
            yjfxnr: "请解锁查看",
            xm: "请解锁查看",
            yzyxxmc: "请解锁查看",
            zcj: "请解锁查看",
            cs: "请解锁查看",
            fs: "请解锁查看"
          }, {
            ssnf: "请解锁查看",
            zymc: "请解锁查看",
            zydm: "请解锁查看",
            yjfxnr: "请解锁查看",
            xm: "请解锁查看",
            yzyxxmc: "请解锁查看",
            zcj: "请解锁查看",
            cs: "请解锁查看",
            fs: "请解锁查看"
          }, {
            ssnf: "请解锁查看",
            zymc: "请解锁查看",
            zydm: "请解锁查看",
            yjfxnr: "请解锁查看",
            xm: "请解锁查看",
            yzyxxmc: "请解锁查看",
            zcj: "请解锁查看",
            cs: "请解锁查看",
            fs: "请解锁查看"
          }];
          loading.value = false;
        }
        if (res.status === 0 && res.result.length > 0) {
          const yearList = [...new Set(res.result.map(ele => ele.ssnf))];
          yearOptions.value = yearList;
          allData.value = res.result;
          selectYear.value = yearList[0];
          tableData.value = res.result.filter(ele => ele.ssnf == yearList[0]);
          loading.value = false;
          isUnlock.value = false;
        } else {
          tableData.value = [];
          allData.value = [];
          selectYear.value = "";
          yearOptions.value = [];
          selectYear.value = "";
          loading.value = false;
        }
      } catch (error) {
        loading.value = false;
        // throw new Error(error)
      }
    }
    // 获取复试名单
    async function getFushiList() {
      try {
        tableData.value = [];
        allData.value = [];
        selectYear.value = "";
        yearOptions.value = [];
        loading.value = true;
        const data = {
          majorOutRelationId: props.majorId
        };
        const result = await fushiList(data);
        const res = JSON.parse(decrypt(result));
        console.log(res, 233);
        if (res.status == 666) {
          ElMessage({
            message: res.msg,
            type: "warning",
            showClose: true
          });
          isUnlock.value = true;
          emit("onChange", {
            isUnlock: true
          });
          tableData.value = [{
            ssnf: "请解锁查看",
            zymc: "请解锁查看",
            zydm: "请解锁查看",
            yjfxnr: "请解锁查看",
            xm: "请解锁查看",
            yzyxxmc: "请解锁查看",
            zcj: "请解锁查看",
            cs: "请解锁查看",
            fs: "请解锁查看"
          }, {
            ssnf: "请解锁查看",
            zymc: "请解锁查看",
            zydm: "请解锁查看",
            yjfxnr: "请解锁查看",
            xm: "请解锁查看",
            yzyxxmc: "请解锁查看",
            zcj: "请解锁查看",
            cs: "请解锁查看",
            fs: "请解锁查看"
          }, {
            ssnf: "请解锁查看",
            zymc: "请解锁查看",
            zydm: "请解锁查看",
            yjfxnr: "请解锁查看",
            xm: "请解锁查看",
            yzyxxmc: "请解锁查看",
            zcj: "请解锁查看",
            cs: "请解锁查看",
            fs: "请解锁查看"
          }, {
            ssnf: "请解锁查看",
            zymc: "请解锁查看",
            zydm: "请解锁查看",
            yjfxnr: "请解锁查看",
            xm: "请解锁查看",
            yzyxxmc: "请解锁查看",
            zcj: "请解锁查看",
            cs: "请解锁查看",
            fs: "请解锁查看"
          }, {
            ssnf: "请解锁查看",
            zymc: "请解锁查看",
            zydm: "请解锁查看",
            yjfxnr: "请解锁查看",
            xm: "请解锁查看",
            yzyxxmc: "请解锁查看",
            zcj: "请解锁查看",
            cs: "请解锁查看",
            fs: "请解锁查看"
          }, {
            ssnf: "请解锁查看",
            zymc: "请解锁查看",
            zydm: "请解锁查看",
            yjfxnr: "请解锁查看",
            xm: "请解锁查看",
            yzyxxmc: "请解锁查看",
            zcj: "请解锁查看",
            cs: "请解锁查看",
            fs: "请解锁查看"
          }, {
            ssnf: "请解锁查看",
            zymc: "请解锁查看",
            zydm: "请解锁查看",
            yjfxnr: "请解锁查看",
            xm: "请解锁查看",
            yzyxxmc: "请解锁查看",
            zcj: "请解锁查看",
            cs: "请解锁查看",
            fs: "请解锁查看"
          }, {
            ssnf: "请解锁查看",
            zymc: "请解锁查看",
            zydm: "请解锁查看",
            yjfxnr: "请解锁查看",
            xm: "请解锁查看",
            yzyxxmc: "请解锁查看",
            zcj: "请解锁查看",
            cs: "请解锁查看",
            fs: "请解锁查看"
          }, {
            ssnf: "请解锁查看",
            zymc: "请解锁查看",
            zydm: "请解锁查看",
            yjfxnr: "请解锁查看",
            xm: "请解锁查看",
            yzyxxmc: "请解锁查看",
            zcj: "请解锁查看",
            cs: "请解锁查看",
            fs: "请解锁查看"
          }, {
            ssnf: "请解锁查看",
            zymc: "请解锁查看",
            zydm: "请解锁查看",
            yjfxnr: "请解锁查看",
            xm: "请解锁查看",
            yzyxxmc: "请解锁查看",
            zcj: "请解锁查看",
            cs: "请解锁查看",
            fs: "请解锁查看"
          }];
          loading.value = false;
        }
        if (res.status === 0 && res.result.length > 0) {
          const yearList = [...new Set(res.result.map(ele => ele.ssnf))];
          yearOptions.value = yearList.reverse();
          allData.value = res.result;
          selectYear.value = yearList[0];
          tableData.value = res.result.filter(ele => ele.ssnf == yearList[0]);
          loading.value = false;
          isUnlock.value = false;
        } else {
          tableData.value = [];
          allData.value = [];
          selectYear.value = "";
          yearOptions.value = [];
          selectYear.value = "";
          loading.value = false;
        }
      } catch (error) {
        loading.value = false;
        // throw new Error(error)
      }
    }
    // 改变选择年份
    const sortTable = ref(null);
    function yearChange(val) {
      if (activeName.value == 1) {
        sortTable.value.clearSort();
      }
      selectYear.value = val;
      const res = allData.value.filter(ele => ele.ssnf == val);
      tableData.value = res;
    }
    onMounted(() => {
      getUseList();
    });
    return (_ctx, _cache) => {
      const _component_el_tab_pane = _resolveComponent("el-tab-pane");
      const _component_el_tabs = _resolveComponent("el-tabs");
      const _component_el_option = _resolveComponent("el-option");
      const _component_el_select = _resolveComponent("el-select");
      const _component_el_table_column = _resolveComponent("el-table-column");
      const _component_QuestionFilled = _resolveComponent("QuestionFilled");
      const _component_el_icon = _resolveComponent("el-icon");
      const _component_el_space = _resolveComponent("el-space");
      const _component_el_table = _resolveComponent("el-table");
      const _component_Key = _resolveComponent("Key");
      const _component_el_button = _resolveComponent("el-button");
      const _component_el_tag = _resolveComponent("el-tag");
      const _directive_loading = _resolveDirective("loading");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createVNode(_component_el_tabs, {
        modelValue: activeName.value,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => activeName.value = $event),
        class: "demo-tabs",
        onTabChange: handleClick
      }, {
        default: _withCtx(() => [_createVNode(_component_el_tab_pane, {
          label: "录取名单",
          name: 1
        }), _createVNode(_component_el_tab_pane, {
          label: "复试名单",
          name: 2
        })]),
        _: 1
      }, 8, ["modelValue"]), _createVNode(_component_el_select, {
        modelValue: selectYear.value,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => selectYear.value = $event),
        placeholder: "选择年份",
        onChange: yearChange
      }, {
        default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(yearOptions.value, ele => {
          return _openBlock(), _createBlock(_component_el_option, {
            label: ele,
            value: ele,
            key: ele
          }, null, 8, ["label", "value"]);
        }), 128))]),
        _: 1
      }, 8, ["modelValue"])]), activeName.value == 1 ? (_openBlock(), _createElementBlock("div", _hoisted_3, [_withDirectives((_openBlock(), _createBlock(_component_el_table, {
        stripe: "",
        "element-loading-text": "数据加载中...",
        "empty-text": "暂无数据，请重新选择条件查询",
        data: tableData.value,
        ref_key: "sortTable",
        ref: sortTable,
        "default-sort": {
          prop: 'cs',
          order: ''
        },
        style: {
          "width": "100%"
        }
      }, {
        default: _withCtx(() => [_createVNode(_component_el_table_column, {
          prop: "ssnf",
          label: "年份",
          width: "100"
        }), _createVNode(_component_el_table_column, {
          prop: "kmycj",
          label: "政治/综合",
          width: "100"
        }), _createVNode(_component_el_table_column, {
          prop: "kmecj",
          label: "外语",
          width: "100"
        }), _createVNode(_component_el_table_column, {
          prop: "kmscj",
          label: "业务课一",
          width: "100"
        }), _createVNode(_component_el_table_column, {
          prop: "kmsicj",
          label: "业务课二",
          width: "100"
        }), _createVNode(_component_el_table_column, {
          prop: "xm",
          label: "姓名"
        }), _createVNode(_component_el_table_column, {
          prop: "yzyxxmc",
          label: "一志愿学校"
        }), _createVNode(_component_el_table_column, {
          prop: "zcj"
        }, {
          header: _withCtx(() => [_createVNode(_component_el_space, null, {
            default: _withCtx(() => [_hoisted_4, _createVNode(_component_el_icon, {
              size: "16px",
              color: "#F56C6C",
              style: {
                "cursor": "pointer"
              },
              onClick: _cache[2] || (_cache[2] = $event => onTips({
                text: '部分院校总分按照百分制计算，复试总分每个学校不同，没有统一标准'
              }))
            }, {
              default: _withCtx(() => [_createVNode(_component_QuestionFilled)]),
              _: 1
            })]),
            _: 1
          })]),
          _: 1
        }), _createVNode(_component_el_table_column, {
          prop: "cs",
          label: "初试成绩",
          sortable: ""
        }), _createVNode(_component_el_table_column, {
          prop: "fs"
        }, {
          header: _withCtx(() => [_createVNode(_component_el_space, null, {
            default: _withCtx(() => [_hoisted_5, _createVNode(_component_el_icon, {
              size: "16px",
              color: "#F56C6C",
              style: {
                "cursor": "pointer"
              },
              onClick: _cache[3] || (_cache[3] = $event => onTips({
                text: '部分院校总分按照百分制计算，复试总分每个学校不同，没有统一标准'
              }))
            }, {
              default: _withCtx(() => [_createVNode(_component_QuestionFilled)]),
              _: 1
            })]),
            _: 1
          })]),
          _: 1
        }), _createVNode(_component_el_table_column, {
          prop: "zxjh",
          label: "专项计划"
        })]),
        _: 1
      }, 8, ["data"])), [[_directive_loading, loading.value]]), isUnlock.value ? (_openBlock(), _createElementBlock("div", _hoisted_6, [_createVNode(_component_el_button, {
        type: "success",
        onClick: onUnlock
      }, {
        default: _withCtx(() => [_createVNode(_component_el_icon, {
          class: "el-icon--right"
        }, {
          default: _withCtx(() => [_createVNode(_component_Key)]),
          _: 1
        }), _createTextVNode(), _hoisted_7]),
        _: 1
      })])) : _createCommentVNode("", true)])) : _createCommentVNode("", true), activeName.value == 2 ? (_openBlock(), _createElementBlock("div", _hoisted_8, [_withDirectives((_openBlock(), _createBlock(_component_el_table, {
        stripe: "",
        "element-loading-text": "数据加载中...",
        "empty-text": "暂无数据，请重新选择条件查询",
        data: tableData.value,
        style: {
          "width": "100%"
        }
      }, {
        default: _withCtx(() => [_createVNode(_component_el_table_column, {
          prop: "ssnf",
          label: "年份",
          width: "100"
        }), _createVNode(_component_el_table_column, {
          prop: "xm",
          label: "姓名"
        }), _createVNode(_component_el_table_column, {
          prop: "zymc",
          label: "专业名称"
        }), _createVNode(_component_el_table_column, {
          prop: "xxfsmc",
          label: "学习方式"
        }), _createVNode(_component_el_table_column, {
          prop: "yjfxnr",
          label: "研究方向"
        }), _createVNode(_component_el_table_column, {
          prop: "cs",
          label: "初试成绩"
        }), _createVNode(_component_el_table_column, {
          prop: "fs",
          label: "复试成绩"
        }), _createVNode(_component_el_table_column, {
          prop: "tag",
          label: "录取情况",
          width: "100",
          filters: [{
            text: '已录取',
            value: '已录取'
          }, {
            text: '未录取',
            value: '未录取'
          }, {
            text: '未知',
            value: '未知'
          }],
          "filter-method": filterTag,
          "filter-placement": "bottom-end"
        }, {
          default: _withCtx(scope => [_createVNode(_component_el_tag, {
            type: scope.row.enrollFlagStr == '已录取' ? 'success' : scope.row.enrollFlagStr == '已录取' ? 'error' : 'info',
            "disable-transitions": ""
          }, {
            default: _withCtx(() => [_createTextVNode(_toDisplayString(scope.row.enrollFlagStr), 1)]),
            _: 2
          }, 1032, ["type"])]),
          _: 1
        })]),
        _: 1
      }, 8, ["data"])), [[_directive_loading, loading.value]]), isUnlock.value ? (_openBlock(), _createElementBlock("div", _hoisted_9, [_createVNode(_component_el_button, {
        type: "success",
        onClick: onUnlock
      }, {
        default: _withCtx(() => [_createVNode(_component_el_icon, {
          class: "el-icon--right"
        }, {
          default: _withCtx(() => [_createVNode(_component_Key)]),
          _: 1
        }), _createTextVNode(), _hoisted_10]),
        _: 1
      })])) : _createCommentVNode("", true)])) : _createCommentVNode("", true)]);
    };
  }
};